export default {
	title: '终端自诊断',
	selectAll: '全选',
	selectedCount: '已选择 {count} 项',
	batchDelete: '批量删除',
	batchDeleteWithCount: '批量删除 ({count})',
	noData: {
		title: '暂无终端自诊断数据',
		description: '当前没有找到相关的终端自诊断数据'
	},
	actions: {
		add: '新增',
		diagnose: '诊断',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		diagnosisSuccess: '诊断完成',
		missingTerminalId: '缺少终端 ID，无法诊断',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		projNo: '所属项目',
		typeId: '终端类型',
		maker: '厂家',
		transferProtocol: '通讯协议',
		model: '型号',
		number: '终端编号',
		upMode: '上行模式',
		downMode: '下行模式',
		placeholder: {
			projNo: '请选择所属项目',
			typeId: '请选择终端类型',
			maker: '请输入厂家',
			transferProtocol: '请选择通讯协议',
			model: '请输入型号',
			number: '请输入终端编号',
			upMode: '请选择上行模式',
			downMode: '请选择下行模式'
		}
	},
	table: {
		number: '终端编号',
		projNo: '项目编号',
		model: '型号',
		downMode: '上行模式',
		pingTime: 'pingTime',
		typeId: '终端类型',
		transferProtocol: '通讯协议',
		remark: '备注',
		warnStatus: '终端状态',
		notDetected: '未检测',
		noConnection: '无法建立连接',
		maker: '厂家'
	},
	detail: {
		normal: '正常',
		abnormal: '异常',
		sdram: 'SDRAM',
		rtc: 'RTC',
		flash: 'Flash',
		uart: 'UART',
		exflash: '扩展 Flash',
		sensor: '传感器状态',
		connected: '接通',
		disconnected: '未接'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定',
		close: '关闭',
		selfDiagnosisDetail: '自诊断详情'
	}
}
